// extracted by mini-css-extract-plugin
module.exports = {"footer":"_777ba","resend-link":"_4e44d","resendLink":"_4e44d","wrapper":"fbfa8","row":"ae606","content":"_36472"};